import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReviewEntriesStatusCellWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  width: 100%;
  min-width: 0;
  overflow: hidden;
`

export const ReviewEntriesStatusTagWrapper = styled.div`
  flex: 1 1 0%;
  min-width: 0;
  overflow: hidden;
`

export const ReviewEntriesStatusTagLabel = styled.span`
  min-width: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`
